import { createAsyncThunk } from '@reduxjs/toolkit';
import { ResponseError } from 'shared/errors/responseError';
import { IThunkApi } from 'shared/types/redux';
import { setDoorCompletedV1Info } from 'shared/services/setDoorCompleted';
import { addNotification } from 'shared/slices/notifications/notificationsSlice';
import { findDoorId } from 'shared/utils/findDoorId/findDoorId';

export const setDoorCompleted = createAsyncThunk<{ points: number; doorId: number }, { doorCode: string }, IThunkApi>(
  'doors/setDoorCompleted',
  async (params, thunkApi) => {
    const { extra, rejectWithValue, dispatch, getState } = thunkApi;

    const { doorCode } = params;

    try {
      const { statusCode, response } = await setDoorCompletedV1Info({
        context: extra,
        doorId: doorCode,
      });

      if (statusCode === 200) {
        const doorId = findDoorId(doorCode);

        return { points: response.points, doorId };
      }

      throw new ResponseError({
        domain: 'setDoorCompleted',
        message: response.message,
      });
    } catch (e) {
      extra.logger.error(e, { description: 'Ошибка api /api/advent/v1/set-door' });

      dispatch(
        addNotification({
          type: 'error',
          text: 'Что-то пошло не так, попробуйте позже',
        }),
      );

      return rejectWithValue(getState().userState.user?.points);
    }
  },
);
